import React from 'react';
import css from './styles.module.scss';
import Description from '@material-ui/icons/Description';
import { IconButton } from '@material-ui/core';
import classNames from 'classnames';

import { Popover, List, ListItem, ListItemText } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import SpeakerNotesOutlinedIcon from '@material-ui/icons/SpeakerNotesOutlined';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        popover: {
            pointerEvents: 'none',
        },
        popoverContent: {
            pointerEvents: 'auto',
            // padding: theme.spacing(2),
        },
        root: {
            width: '100%',
            maxWidth: 360,
            // padding: theme.spacing(2),
            backgroundColor: theme.palette.background.paper,
        },
    })
);

interface DownloadButtonProps {
    title?: string;
    className?: string;
    onClick: () => void;
    buttonFor?: string;
    isPopver?: boolean;
    color?: 'red' | 'darkRed' | 'orange' | 'blue' | 'darkBlue' | 'green' | 'yellow' | 'gray' | 'black';
}

export const DownloadButton: React.FC<DownloadButtonProps> = ({ title, color, className, onClick, buttonFor, isPopver }) => {
    const classes = useStyles();

    const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
    const open = Boolean(anchorEl);
    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };
    return (
        <>
            <IconButton
                onClick={onClick}
                className={classNames(css.module, color && css[color], className)}
                aria-owns={open ? 'mouse-over-popover' : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                title={title}
            >
                {buttonFor === 'preview' ? <PictureAsPdf /> : buttonFor === 'save' ? <SpeakerNotesOutlinedIcon /> : <Description />}
            </IconButton>

            {isPopver && (
                <Popover
                    id="mouse-over-popover"
                    className={classes.popover}
                    classes={{
                        paper: classes.popoverContent,
                    }}
                    open={open}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    onClose={handlePopoverClose}
                    disableRestoreFocus
                    PaperProps={{ onMouseLeave: handlePopoverClose }}
                >
                    <List component="nav" className={classes.root} aria-label="contacts">
                        <ListItem button>
                            <ListItemText primary="View" />
                        </ListItem>

                        <ListItem button>
                            <ListItemText primary="Edit" />
                        </ListItem>

                        <ListItem button>
                            <ListItemText primary="Delete" />
                        </ListItem>
                    </List>
                </Popover>
            )}
        </>
    );
};
